import React, { useState, useEffect } from 'react'
import './Modal.css'
import { useTranslation } from 'react-i18next'

function CustomPromptModal({
	isOpen,
	onClose,
	onSubmit,
	title,
	placeholder,
	submitButtonText,
	defaultValue = '',
}) {
	const [inputValue, setInputValue] = useState('')
	const { t } = useTranslation()

	// Update input value when defaultValue changes
	useEffect(() => {
		if (isOpen && defaultValue) {
			setInputValue(defaultValue);
		} else if (isOpen && !defaultValue) {
			setInputValue('');
		}
	}, [isOpen, defaultValue]);

	const handleSave = () => {
		if (onSubmit) {
			onSubmit(inputValue)
		}
		setInputValue('')
		onClose()
	}

	if (!isOpen) {
		return null
	}

	return (
		<div className='modal-overlay'>
			<div className='modal'>
				<div className='modal-content'>
					<div className='modal-header'>
						{title}
					</div>
					<div className='modal-body'>
						<textarea
							value={inputValue}
							onChange={e => setInputValue(e.target.value)}
							onKeyDown={e => {
								if (e.key === 'Enter' && !e.shiftKey) {
									e.preventDefault()
									handleSave()
								}
							}}
							placeholder={placeholder}
						/>
					</div>
					<div className='modal-footer'>
						<button
							onClick={onClose}
							className='modal-button cancel'
						>
							{t('cancel')}
						</button>
						<button
							onClick={handleSave}
							className='modal-button save-start'
						>
							{submitButtonText}
						</button>
					</div>
				</div>
			</div>
		</div>
	)
}

export default CustomPromptModal